"use strict";

export class TransformHandler {
    static updateAnchor(object) {
        let lossyScale = object.lossyScale;
        object.x = object.anchoring.anchor.x * 
            (object.anchoring.anchorBounds.width / lossyScale / 2) +
            object.anchoring.margin.x;
        object.y = object.anchoring.anchor.y * 
            (object.anchoring.anchorBounds.height / lossyScale / 2) +
            object.anchoring.margin.y;
    }
    static updateAnchor3D(object) {
        let lossyScale = object.lossyScale;
        object.x = object.anchoring.anchor.x * 
            (object.anchoring.anchorBounds.width / lossyScale / 2) +
            object.anchoring.margin.x;
        object.y = object.anchoring.anchor.y * 
            (object.anchoring.anchorBounds.height / lossyScale / 2) +
            object.anchoring.margin.y;
        object.position3d.z = object.anchoring.margin.z;
    }

    static updateMargin(object) {
        object.x = object.anchoring.margin.x;
        object.y = object.anchoring.margin.y;
    }
    static updateMargin3D(object) {
        object.position3d.x = object.anchoring.margin.x;
        object.position3d.y = object.anchoring.margin.y;
        object.position3d.z = object.anchoring.margin.z;
    }

    static updateGraphicsScale(object) {
        if (object.stretchToFullscreen) {
            object.setSize(
                object._useBounds.width / object.lossyScaleX,
                object._useBounds.height / object.lossyScaleY);
        } else if (object.stretchOnX) {
            if (object.preserveAspectRatio) {
                object.setSize(
                    object._useBounds.width / object.lossyScaleX,
                    object._useBounds.width / object._sizeRatio / object.lossyScaleX
                );
            } else {
                object.setWidth(object._useBounds.width / object.lossyScaleX);
            }
        } else if (object.stretchOnY) {
            if (object.preserveAspectRatio) {
                object.setSize(
                    object._useBounds.height / object._sizeRatio / object.lossyScaleY,
                    object._useBounds.height / object.lossyScaleY
                );
            } else {
                object.setHeight(object._useBounds.height / object.lossyScaleY);
            }
        } else if (object.keepFullscreen) {
            let bounds = {...object._useBounds};
            if (object._useBounds.width < object._useBounds.height &&
                object._sizeRatio < 1 &&
                object._sizeRatio < object._useBounds.width / object._useBounds.height) {
                bounds.height = object._useBounds.width / object._sizeRatio;
            } else if (object._sizeRatio > object._useBounds.width / object._useBounds.height) {
                bounds.width = object._useBounds.height * object._sizeRatio;
            } else {
                bounds.height = object._useBounds.width / object._sizeRatio;
            }
            object.setSize(bounds.width / object.lossyScaleX, bounds.height / object.lossyScaleY);
        } else {
            object._refreshScale();
        }
    }
}